import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

function HeaderImage() {
    const location = useLocation();
    let headerText = "";

    if (location.pathname === "/services") {
        headerText = "Usługi";
    } else if (location.pathname === "/pricing") {
        headerText = "Cennik";
    } else if (location.pathname === "/salon") {
        headerText = "Salon";
    } else if (location.pathname === "/contact") {
        headerText = "Kontakt";
    }

    return (
        <Box sx={{ position: "relative", width: "100%", height: "20vh", mb: 6 }}>
            <Box
                component="img"
                src="/background-blur.jpg"
                alt="Header image"
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
                }}
            >
                {headerText}
            </Box>
        </Box>
    );
}

export default HeaderImage;
